var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRocket = function SvgRocket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 66 66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.79 27.9v6.184l-1.278 1.423-1.423-4.124V27.9h2.701z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.979 27.9v3.484l-1.212 3.912-1.489-1.212V27.9h2.7z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.432 41.404H12.278v-7.32l2.701-2.7 8.508-8.48.945 18.5z",
    fill: "#D2C5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79 34.084v7.32H40.636l.946-18.5 8.507 8.48 2.701 2.7z",
    fill: "#C4B3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.987 41.404l-2.7 5.401H25.781l-2.7-5.401 3.024-2.701h12.829l3.052 2.7z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.987 41.404l-2.7 5.401h-6.753v-8.102h6.401l3.052 2.7z",
    fill: "#E56705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.15 14.396c.27.89-2.187 1.782-1.971 2.7h-11.29c.216-.918-2.241-1.81-1.971-2.7 1.431-4.646 3.62-9.075 6.536-12.964L32.534 0l1.08 1.432c2.917 3.89 5.105 8.318 6.537 12.964z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.179 17.096h-5.645V.002l1.08 1.431c2.917 3.89 5.105 8.318 6.536 12.964.27.89-2.187 1.782-1.971 2.7z",
    fill: "#E56705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.987 26.549v14.854H23.08V26.55c0-3.187.378-6.347 1.108-9.453.216-.918.459-1.81.729-2.7h15.233c.27.89.513 1.782.729 2.7a41.307 41.307 0 011.107 9.453z",
    fill: "#EDE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.987 26.55v14.854h-9.453V14.396h7.616c.27.89.514 1.782.73 2.7a41.298 41.298 0 011.107 9.453z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.885 36.002V30.6h-2.7v5.401h2.7z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.534 19.797a4.046 4.046 0 00-4.05 4.051 4.046 4.046 0 004.05 4.052 4.046 4.046 0 004.052-4.052 4.046 4.046 0 00-4.052-4.05z",
    fill: "#00C0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.781 58.316h2.701v-8.81h-2.7v8.81zM33.885 63.717V55.48h-2.701v8.238h2.7z",
    fill: "#25D9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.586 58.315h2.7v-8.81h-2.7v8.81z",
    fill: "#00C0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.534 27.9v-8.103a4.046 4.046 0 014.051 4.052 4.046 4.046 0 01-4.051 4.05z",
    fill: "#00ABE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.534 36.002h1.35V30.6h-1.35v5.402z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.885 55.479h-1.35v8.238h1.35v-8.238z",
    fill: "#00C0F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-45 39.272 16.267)",
    d: "M0 0h46.01v46.01H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket.0d3709c7.svg";
export { ForwardRef as ReactComponent };